var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyus8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: GothamRounded-Bold, 'Gotham Rounded';\n        font-size: 22px;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke: #000;\n      }\n\n      .cls-6 {\n        letter-spacing: .05em;\n      }\n\n      .cls-7 {\n        letter-spacing: .02em;\n      }\n\n      .cls-2 {\n        fill: #4a00e8;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-3 {\n        fill: #e0ef4d;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.23,186.21s7.56-3.02,15.31-1.66c7.75,1.37,11.8,4.97,11.8,4.97l-19.84,8.14-7.26-11.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.18,202.8v15.3c0,1.48,1.2,2.69,2.69,2.69h91.5s14.05,.64,43.61-6.59c11.39-2.79,21.27-7.3,24.08-10.91,0,0,1.36-10.42-7.92-15.47l-17.23,4.75-58.11,4.31-62.89,3.59-12.97-.35c-1.51-.04-2.76,1.17-2.76,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.36,134.85s-5.64-8.46-8.7-8.44c-2.99,.02-7.43,6.68-8.76,11.03l17.46-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.54,136.65c-1.38-.08-2.41,1.26-1.95,2.56,.89,2.54,2.07,6.29,2.32,8.93,.42,4.35,.67,10.71-2.01,17.49-2.68,6.78-7.45,28.2-5.52,34.47,0,0,83.27,.61,90.75,.24s37.4-4.41,43.76-7.78c0,0-2.69-6.96-19.37-10.7-16.68-3.74-25.29-5.56-34.56-14.17-8.81-8.18-20.86-22.33-26.18-33.38-.48-1-1.59-1.53-2.67-1.3-5.95,1.25-25.1,4.83-44.57,3.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 103.82,
    cy: 162.7,
    r: 14.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.49,167.25l-2.5,.89c-.64,.23-1.31-.26-1.29-.94l.07-2.66c0-.22-.06-.44-.2-.62l-1.62-2.11c-.41-.54-.16-1.32,.49-1.52l2.55-.75c.21-.06,.4-.2,.52-.38l1.5-2.19c.38-.56,1.21-.56,1.59,0l1.5,2.19c.13,.18,.31,.32,.52,.38l2.55,.75c.65,.19,.91,.98,.49,1.52l-1.62,2.11c-.14,.18-.21,.39-.2,.62l.07,2.66c.02,.68-.65,1.16-1.29,.94l-2.5-.89c-.21-.07-.44-.07-.65,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 123.05,
    y1: 145.46,
    x2: 133.41,
    y2: 140.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.06,147.52c-.79,0-1.54-.45-1.88-1.22-.47-1.04,0-2.26,1.03-2.72l10.36-4.66c1.04-.47,2.26,0,2.72,1.03,.47,1.04,0,2.26-1.03,2.72l-10.36,4.66c-.27,.12-.56,.18-.84,.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 136.61,
    y1: 164.05,
    x2: 145.77,
    y2: 157.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.61,166.11c-.63,0-1.26-.29-1.66-.84-.67-.92-.47-2.21,.44-2.88l9.16-6.71c.92-.67,2.21-.47,2.88,.44,.67,.92,.47,2.21-.44,2.88l-9.16,6.71c-.37,.27-.79,.4-1.22,.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 177.18,
    y1: 188.68,
    x2: 183.27,
    y2: 179.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.17,190.74c-.38,0-.76-.1-1.1-.32-.96-.61-1.24-1.88-.63-2.84l6.09-9.59c.61-.96,1.88-1.24,2.84-.63,.96,.61,1.24,1.88,.63,2.84l-6.09,9.59c-.39,.62-1.06,.95-1.74,.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 153.43,
    y1: 179.06,
    x2: 161.46,
    y2: 171.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.43,181.12c-.53,0-1.05-.2-1.46-.6-.8-.8-.8-2.11,0-2.91l8.03-8.03c.8-.8,2.11-.8,2.91,0,.8,.8,.8,2.11,0,2.91l-8.03,8.03c-.4,.4-.93,.6-1.46,.6Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.28,68.22H233.01c13.67,0,24.77,11.1,24.77,24.77V232.53H44.51V92.99c0-13.67,11.1-24.77,24.77-24.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 32.66,
    y: 224.3,
    width: 236.96,
    height: 13.4,
    rx: 6.7,
    ry: 6.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69.43,
    y: 232.53,
    width: 9.43,
    height: 16.47,
    rx: 4.71,
    ry: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 223.43,
    y: 232.53,
    width: 9.43,
    height: 16.47,
    rx: 4.71,
    ry: 4.71
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 228.16,
    y: 137.17,
    width: 59.23,
    height: 59.23,
    rx: 12.99,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 257.78,
    y1: 153.15,
    x2: 257.78,
    y2: 180.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 244.14,
    y1: 166.79,
    x2: 271.41,
    y2: 166.79
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.45,
    y: 38.9,
    width: 129.39,
    height: 58.63,
    rx: 29.32,
    ry: 29.32
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(116.9 63.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 0,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 15.47,
    y: 0
  }, "OUR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.36,
    y: 23
  }, "BRAND"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus8);
export default __webpack_public_path__ + "static/media/whyus8.d284dac4dac83f50df406f776e783d30.svg";
export { ForwardRef as ReactComponent };